<template>
  <Dialog :show="show" @cancel="cancelDialog">
    <div class="logistics">
      <div class="logistics__right">
        <div class="logistics__title">亚马逊FBA物流参考报价</div>
        <div class="logistics-module">
          <div class="logistics__line"
            v-for="item in logisticsInputData"
            :key="item.data">
            <div class="logistics__name">{{ item.name }}:</div>
            <div class="logistics__input"
              :class="{
                'logistics__input--size': item.data === 'size',
                'logistics__input--box' : item.data === 'box',
                'logistics__input--status' : item.data === 'logisticsStatus',
                'logistics__input--disable' : item.isDisable,
                'logistics__input--prompt': isPrompt && logisticsQuotation[item.data] == ''
              }">
              <!-- 外箱尺寸 -->
              <template v-if="item.data === 'size'">
                <el-input
                  v-for="item in logisticsSizeInputData"
                  :class="{'logistics__input--prompt' : isPrompt && logisticsQuotation[item.data] == ''}"
                  :key="item.data"
                  :value="logisticsQuotation[item.data]"
                  @input="inputChangeInformUp($event, item.data)"
                  size="mini"></el-input>
              </template>
              <!-- 装箱数量 -->
              <template v-else-if="item.data === 'box'">
                <div style="position: relative;"
                  v-for="item in logisticsBoxInputData"
                  :class="{'logistics__input--prompt' : isPrompt && logisticsQuotation[item.data] == ''}"
                  :key="item.data">
                  <el-input
                    :value="logisticsQuotation[item.data]"
                    @input="inputChangeInformUp($event, item.data)"
                    size="mini"></el-input>
                  <span v-if="item.data === 'num'" class="logistics__unit">{{ unit }}</span>
                  <span v-else-if="item.data === 'weight'" class="logistics__unit">kg</span>
                </div>
              </template>
              <!-- 产品状况 -->
              <template v-else-if="item.data === 'logisticsStatus'">
                <el-select
                  size="mini"
                  popper-class="productStatusSelect"
                  ref="productStatusSelect"
                  placeholder=""
                  :value="logisticsQuotation.logisticsStatus"
                  multiple
                  @input="inputChangeInformUp($event, item.data)">
                  <div class="logistics__input-status">
                    <div class="logistics__input-module">
                      <div class="logistics__input-module__title">
                        必选项1
                        <span class="logistics__input-module__tip">(单选)</span>
                      </div>
                      <el-option
                        v-for="item in item.array.slice(0, 3)"
                        :key="item"
                        :label="item"
                        :value="item">
                        <el-checkbox
                          :label="item"
                          :value="judgeStatusCheckBox(item)"
                          @change="statusCheckChange($event, item)"></el-checkbox>
                      </el-option>
                    </div>
                    <div class="logistics__input-module">
                      <div class="logistics__input-module__title">
                        必选项2
                        <span class="logistics__input-module__tip">(单选)</span>
                      </div>
                      <el-option
                        v-for="item in item.array.slice(3, 6)"
                        :key="item"
                        :label="item"
                        :value="item">
                        <el-checkbox
                          :label="item"
                          :value="judgeStatusCheckBox(item)"
                          @change="statusCheckChange($event, item)"></el-checkbox>
                        </el-option>
                    </div>
                    <div class="logistics__input-module">
                      <div class="logistics__input-module__title">
                        非必选项
                        <span class="logistics__input-module__tip">(可多选,请如实勾选)</span>
                        <el-option
                          v-for="item in item.array.slice(6, 9)"
                          :key="item"
                          :label="item"
                          :value="item">
                          <el-checkbox
                          :label="item"
                          :value="judgeStatusCheckBox(item)"
                          @change="statusCheckChange($event, item)"></el-checkbox>
                        </el-option>
                      </div>
                    </div>
                  </div>
                  <div class="logistics__bottom">
                    <div class="logistics__btn" :style="{'width': getScaleByUI(80 + 'px')}" @click="productStatusSelectBtnClick">确认</div>
                  </div>
                </el-select>
              </template>
              <!-- 寄件地址 -->
              <template v-else-if="item.data === 'shippingAddress'">
                <el-select
                  size="mini"
                  placeholder=""
                  popper-class="shippingAddressSelect"
                  ref="shippingAddressSelect"
                  :value="logisticsQuotation[item.data]">
                  <el-option v-show="false" value="1"/>
                  <div class="logistics__input-address">
                    <div class="logistics__input-address-menu">
                      <div class="logistics__input-address-menu__top">
                        <div
                          class="logistics__input-address-menu__option"
                          :class="{'logistics__input-address-menu__option--select': logisticsAddressMenuSelect === item.id}"
                          v-for="item in logisticsAddressShowMenu"
                          :key="item.id"
                          @click="addressMenuClick(item.id)">{{ item.name }}</div>
                      </div>
                      <div class="logistics__input-address-menu-common">
                        <div
                          class="logistics__input-address-menu-common__city"
                          v-for="(item, index) in logisticsAddress"
                          :key="item.name + item.id"
                          @click="addressMenuOptionClick(item.id, item.name, logisticsAddressMenuSelect, index)">
                          {{ item.name }}
                        </div>
                      </div>
                    </div>
                  </div>
                </el-select>
              </template>
              <!-- 送仓地址 -->
              <template v-else-if="item.data === 'deliveryAddress'">
                <el-select
                  size="mini"
                  placeholder=""
                  :value="logisticsQuotation[item.data]"
                  @input="inputChangeInformUp($event, item.data)">
                  <el-option
                    v-for="item in logisticsQuotation.deliveryAddressArray"
                    :key="item.id"
                    :value="item.id"
                    :label="item.name"></el-option>
                </el-select>
              </template>
              <!-- 正常选择框 -->
              <template v-else>
                <el-select
                  size="mini"
                  placeholder=""
                  :disabled="item.isDisable"
                  :value="logisticsQuotation[item.data]"
                  @input="inputChangeInformUp($event, item.data)">
                  <el-option
                    v-for="(item, index) in item.array"
                    :key="index"
                    :value="index"
                    :label="item"></el-option>
                </el-select>
              </template>
            </div>
          </div>
          <div class="logistics__bottom">
            <div class="logistics__btn" @click="clearData">清空内容</div>
            <div class="logistics__btn" @click="calculateShipPrice">运费计算</div>
          </div>
        </div>
      </div>
      <div class="logistics__left">
        <Table
          :head="logisticsTableHead"
          :body="logisticsTableData"
          :radioIndex="tableRadioIndex"
          :summaryData="tableSummaryData"
          width="920"
          no-data-prompt-text="请输入数据后点击“运费计算”"
          @changeRadioIndex="changeRadioIndex"></Table>
        <div class="logistics__bottom">
          <div class="logistics__btn" @click="tableSaveBtnClick">导出数据</div>
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script>
import { LogisticsQuotationInputNewModule, LogisticsQuotation, LogisticsMethod } from 'common/dataClass/Logistics'
import globalData from 'common/globalData'
import DefaultAxios from 'service/default'
import logisticsAxios from 'service/logistics'
import { City } from 'common/dataClass/Default'
import Table from 'components/common/Table.vue'
import Dialog from 'components/common/Dialog.vue'
export default {
  name: 'logisticsDialog',
  components: {
    Table,
    Dialog
  },
  data(){
    return{
      /**物流报价输入模块 */
      logisticsInputData: LogisticsQuotationInputNewModule.NEWINPUT(),
      /**物流报价输入模块尺寸 */
      logisticsSizeInputData: LogisticsQuotationInputNewModule.NEWSIZE(),
      /**物流报价输入模块装箱数量 */
      logisticsBoxInputData: LogisticsQuotationInputNewModule.NEWBOX(),
      /**产品状态 */
      productStatusInputOptions: globalData.logisticsStatusInputOptions,
      /**物流参考报价菜单 */
      logisticsAddressMenu: LogisticsQuotationInputNewModule.NEWADDRESSMENU(),
      logisticsAddressMenuSelect: 'common',
      /**物流参考报价常用城市 */
      logisticsCommonAddress: LogisticsQuotationInputNewModule.NEWCOMMONADDRESS(),
      /**省份 */
      provinceArray: [],
      /**市 */
      cityArray: [],
      /**区 */
      countyArray: [],
      /**表头数据 */
      logisticsTableHead: LogisticsQuotationInputNewModule.NEWTABLEHEAD(),
      /**表格数据 */
      logisticsTableData: LogisticsQuotationInputNewModule.NEWTABLETESTDATA(),
      /**汇总数据 */
      tableSummaryData: LogisticsQuotationInputNewModule.NEWTABLESUMMARY(),
      /**表格选择索引 */
      tableRadioIndex: null,
      /**提示未输入数据 */
      isPrompt: false,
    }
  },
  props:{
    /**是否显示弹窗 */
    show: {
      type: Boolean,
      default: false
    },
    /**物流报价数据 */
    logisticsQuotation: {
      type: LogisticsQuotation
    },
    /**计价单位 */
    unit: {
      type: String,
      default: '套'
    }
  },
  computed: {
    /**需要显示的寄件地址菜单子项 */
    logisticsAddressShowMenu(){
      return this.logisticsAddressMenu.filter(e => e.show)
    },
    /**寄件地址显示城市 */
    logisticsAddress(){
      let obj = {
        'common': this.logisticsCommonAddress,
        'province': this.provinceArray,
        'city': this.cityArray,
        'county': this.countyArray
      }
      return obj[this.logisticsAddressMenuSelect]
    },
    /**表格汇总基础数据 */
    summaryBasicData(){
      let obj = {
        'long' : this.logisticsQuotation.long,
        'width' : this.logisticsQuotation.width,
        'height' : this.logisticsQuotation.height,
        'num' : this.logisticsQuotation.num,
        'weight' : this.logisticsQuotation.weight,
        'stockNum' : this.logisticsQuotation.stockNum,
        'stockPrice' : this.logisticsQuotation.stockPrice,
      }
      return obj
    }
  },
  methods: {
    /**关闭弹窗 */
    cancelDialog(){
      this.$emit('cancel', false)
      this.logisticsTableData.splice(0, this.logisticsTableData.length)
    },
    /**输入框数据改变 通知父组件 */
    inputChangeInformUp(value, key){
      let eventValue = value
      if(key === 'logisticsStatus' && Array.isArray(eventValue)){
        let arr = eventValue.map(v => this.productStatusInputOptions.indexOf(v))
        let resultIndexArr = []
        let battery = arr.filter(i => i >=0 && i <= 2).pop()
        let magnetic = arr.filter(i => i >=3 && i <= 5).pop()
        let otherArr = arr.filter(i => i >= 6)
        if(battery !== undefined) resultIndexArr.push(battery)
        if(magnetic !== undefined) resultIndexArr.push(magnetic)
        resultIndexArr = resultIndexArr.concat(otherArr)
        eventValue = resultIndexArr.map(i => this.productStatusInputOptions[i])
      }
      this.$emit('logisticsDataChange', {
        key: key,
        value: eventValue
      })
    },
    /**保留小数点数位 */
    keepDecimalPoint: globalData.keepDecimalPoint,
    /**产品状态select checkBox点击事件 */
    statusCheckChange(bool, label){
      let arr = this.logisticsQuotation.logisticsStatus
      if(!bool){
        arr.push(label)
      }else{
        arr = arr.filter(s => s != label)
      }
      this.inputChangeInformUp(arr, 'logisticsStatus')
    },
    /**判断当前checkBox是否被选择 */
    judgeStatusCheckBox(label){
      return this.logisticsQuotation.logisticsStatus.includes(label)
    },
    /**寄件地址菜单点击事件 */
    addressMenuClick(id){
      this.logisticsAddressMenuSelect = id
    },
    /**寄件地址菜单是否显示 */
    addressMenuShowChange(index, name){
      let arr = LogisticsQuotationInputNewModule.NEWADDRESSMENU()
      return this.logisticsAddressMenu.map((e, i) => {
        if(i <= index){
          i == index - 1 && (e.name = name)
          i == index && (e.name = arr[i].name)
          e.show = true
        }
        else { e.show = false }
        return e
      })
    },
    /**寄件地址菜单子项点击事件 */
    async addressMenuOptionClick(id, name, type, index){
      let res = null
      // 地址分隔符号
      let addressDelimiter = '-'
      let address = this.logisticsQuotation.shippingAddress
      let obj = {
        'common': async(id, name, index) => {
          address = ''
          res = await Promise.all([
            DefaultAxios.getCity({id}),
            DefaultAxios.getCity({id: this.logisticsCommonAddress[index].provinceId})
          ])
          // 城市对应对应区域
          if(res[0].data.code === 1){
            this.logisticsAddressMenu[1].name = this.logisticsCommonAddress[index].provinceName
            this.logisticsAddressMenu = this.addressMenuShowChange(3, name)
            this.countyArray = res[0].data.info.map(e => new City(e.cityName, e.cityId))
            this.logisticsAddressMenuSelect = 'county'
            address = this.logisticsCommonAddress[index].provinceName + addressDelimiter + name
          }
          // 省份对应城市
          if(res[1].data.code === 1){
            this.cityArray = res[1].data.info.map(e => new City(e.cityName, e.cityId))
          }
        },
        'province': async(id, name) => {
          res = await DefaultAxios.getCity({id})
          if(res.data.code === 1){
            this.logisticsAddressMenu = this.addressMenuShowChange(2, name)
            this.cityArray = res.data.info.map(e => new City(e.cityName, e.cityId))
            this.logisticsAddressMenuSelect = 'city'
            address = name
          }
        },
        'city': async(id, name) => {
          res = await DefaultAxios.getCity({id})
          if(res.data.code === 1){
            this.logisticsAddressMenu = this.addressMenuShowChange(3, name)
            this.countyArray = res.data.info.map(e => new City(e.cityName, e.cityId))
            this.logisticsAddressMenuSelect = 'county'
            address = address.split(addressDelimiter)[0] + addressDelimiter + name
          }
        },
        'county': (id, name) => {
          this.logisticsAddressMenu = this.addressMenuShowChange(4, name)
          let addressArray = address.split(addressDelimiter)
          address = addressArray[0] + addressDelimiter + addressArray[1] + addressDelimiter + name
          this.inputChangeInformUp(id, 'shippingAddressIId')
          this.$refs.shippingAddressSelect[0].blur()
        }
      }
      await obj[type](id, name, index)
      this.inputChangeInformUp(address, 'shippingAddress')
    },
    /**清空数据 */
    clearData(){
      this.$emit('clear')
      this.logisticsAddressMenu = LogisticsQuotationInputNewModule.NEWADDRESSMENU()
      this.logisticsAddressMenuSelect = 'common'
      this.logisticsTableData.splice(0, this.logisticsTableData.length)
    },
    /**计算运费 */
    async calculateShipPrice(){
      const loading = this.$loading({
          lock: true,
          text: '计算中，请稍后',
          fullscreen: true
        })
      this.isPrompt = true
      this.logisticsTableData.splice(0, this.logisticsTableData.length)
      if(this.logisticsQuotation.judgeSendCalculateAxios()){
        let data = this.logisticsQuotation.getCalculateShipPriceBody
        let res = await logisticsAxios.calculateShipPrice(data)
        if(res.data.code == 1){
          let arr = res.data.info
          let transportDay, totalPrice, tariff, shipTitle
          this.logisticsTableData = arr.map(e => {
            transportDay = e.transportDay.split('-').join('~')
            totalPrice = '¥' + globalData.keepDecimalPoint(e.totalPrice, 0)
            tariff = e.tariff.split('/').join('+<br>')
            shipTitle = e.shipTitle.split('/').join('+<br>')
            return new LogisticsMethod(e.carrier, e.jjType, shipTitle, '1~2', '1~3', transportDay, '1~3', '1~5', tariff, totalPrice)
          })
          this.logisticsTableData = this.logisticsTableData.filter(e => {
            return e.sqbs.split('+<br>')[0] === this.logisticsQuotation.sqbs
          })
        }else{
          this.$message.error(res.data.info)
        }
        loading.close()
      }else{
        this.$message.error('请将数据补充完整')
        loading.close()
      }
    },
    /**表格选择索引改变事件 */
    changeRadioIndex(index){
      this.tableRadioIndex = index
    },
    /**表格保存按钮点击事件 */
    tableSaveBtnClick(){
      if(this.tableRadioIndex == null){
        this.$message.error('请选择物流渠道')
        return;
      }
      this.$emit('changeProductData', {
        domesticFreight: 0,
        internationFreight: Number(this.logisticsTableData[this.tableRadioIndex].freight.split('¥')[1])
      })
      this.cancelDialog()
    },
    /**行内元素 px 转 rem */
    getScaleByUI: globalData.getScaleByUI,
    /**产品状态按钮点击事件 */
    productStatusSelectBtnClick(){
      this.$refs.productStatusSelect[0].blur()
    }
  },
  watch: {
    summaryBasicData: {
      handler(newVal){
        let volume = newVal.long * newVal.width * newVal.height * this.logisticsQuotation.boxNum / 1000000
        this.tableSummaryData[0].data = this.logisticsQuotation.boxNum * newVal.weight
        this.tableSummaryData[1].data = this.keepDecimalPoint(volume, 4)
        this.tableSummaryData[2].data = this.logisticsQuotation.boxNum
        this.tableSummaryData[3].data = newVal.stockNum * newVal.stockPrice
      },
      immediate: true
    }
  },
  async created(){
    let res = await DefaultAxios.getProvince()
    if(res.data.code === 1){
      this.provinceArray = res.data.info.map(e => new City(e.provinceName, e.provinceId))
    }
  }
}
</script>

<style lang="scss">
.shippingAddressSelect{
  // 取消最大高度限制
  .el-select-dropdown__wrap{
    max-height: none !important;
    height: 310px;
  }
  // 取消溢出隐藏
  .el-select-dropdown__list{
    overflow: visible !important;
  }
}
.logistics__input--status{
  .el-select__tags{
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    .el-tag{
      display: inline-block;
      max-width: 270px !important;
      overflow: hidden;
    }
  }
}
.logistics__input--disable{
  .el-input.is-disabled .el-input__inner {
    background: #e2e2e2;
    color: #bebebe;
    -webkit-text-fill-color: #949494;
  }
  .el-input__suffix{
    display: none;
  }
}
.logistics__input--prompt{
  .el-input__inner{
    border-color: red;
  }
}
</style>

<style scoped lang="scss">
.logistics{
  width: 1410px;
  display: flex;
  &__right{
    background: #04305b;
    color: white;
    font-size: 12px;
    padding: 10px 5px;
  }
  &__title{
    font-size: 16px;
    font-weight: bold;
  }
  &__line{
    display: flex;
    align-items: center;
    margin: 10px;
    ::v-deep{
      .el-input__inner{
        border-radius: 0;
        width: 270px;
        text-align: center;
      }
    }
  }
  &__name{
    width: 120px;
  }
  &__input{
    width: 270px;
    display: flex;
    justify-content: space-between;
    &--size{
      ::v-deep{
        .el-input__inner{
          width: 88px;
        }
      }
      & > :last-child{
        margin-right: -4px;
      }
    }
    &--box{
      ::v-deep{
        .el-input__inner{
          width: 132px;
        }
      }
    }
    &-status{
      display: flex;
      padding: 5px 10px;
    }
    &-module{
      &__title{
        color: #00a0c7;
      }
      &__tip{
        color: black;
      }
    }
    &-address{
      width: 600px;
      &-menu{
        padding:0 20px;
        &__top{
          width: 100%;
          border-bottom: 1px solid #04305b;
        }
        &__option{
          display: inline-block;
          font-size: 16px;
          width: 140px;
          padding: 10px 0;
          margin-bottom: -3px;
          text-align: center;
          font-weight: bold;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          &:hover{
            cursor: pointer;
            opacity: .8;
          }
        }
        &__option--select{
          background: #04305b;
          color: white;
          &:hover{
            opacity: 1;
            cursor: auto;
          }
        }
        &-common{
          display: flex;
          flex-wrap: wrap;
          margin: 0 auto;
          &__city{
            // display: flex;
            // align-items: center;
            // justify-content: center;
            font-size: 14px;
            width: 83px;
            height: 40px;
            line-height: 40px;
            margin: 0 5px;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            &:hover{
              cursor: pointer;
              opacity: .8;
            }
          }
        }
      }
    }
  }
  &__unit{
    position: absolute;
    top: 50%;
    right: 5px;
    transform: translateY(-50%);
    color: #646464;
  }
  &__bottom{
    display: flex;
    justify-content: end;
    align-items: center;
  }
  &__btn{
    color: white;
    font-weight: bold;
    padding: 8px 16px;
    background: #2d9ae4;
    margin: 4px 10px;
    font-size: 12px;
    text-align: center;
    &:hover{
      cursor: pointer;
      opacity: .8;
    }
  }
  &__left{
    .logistics__bottom{
      position: absolute;
      right: 10px;
      transform: translateY(-30px);
    }
    .logistics__btn{
      padding: 8px 36px;
    }
  }
}
</style>
